export default __webpack_public_path__ + "static/media/header-photo.ed0bab09.jpg";